
import React from 'react';

interface GameFooterProps {
  duration: string;
  description: string;
}

const GameFooter = ({ duration, description }: GameFooterProps) => {
  return (
    <div className="bg-white p-4 border-t border-gray-200">
      <div className="container mx-auto max-w-4xl">
        <div className="flex flex-wrap justify-between items-center">
          <p className="text-sm text-gray-500">Duration: {duration || 'Unknown'}</p>
          <p className="text-sm text-gray-500">{description || 'No description available'}</p>
        </div>
      </div>
    </div>
  );
};

export default GameFooter;
